const allLenders = [
    {
      slug: 'sallie-mae',
      rateSlug: 'sallie-mae',
      name: 'Sallie Mae',
      minAmount: 1000,
      maxAmount: 200000,
    },
    {
      slug: 'discover',
      rateSlug: 'discover',
      name: 'Discover',
      minAmount: 1000,
      maxAmount: 200000,
    },
    {
      slug: 'citizens-bank',
      rateSlug: 'citizens-bank',
      name: 'Citizens',
      minAmount: 1000,
      maxAmount: 350000,
    },
    {
      slug: 'suntrust',
      rateSlug: 'suntrust',
      name: 'Suntrust',
      minAmount: 1001,
      maxAmount: 65000,
    },
    {
      slug: 'mefa',
      rateSlug: 'mefa',
      name: 'MEFA',
      minAmount: 2000,
      maxAmount: 100000,
    },
    {
      slug: 'cas',
      rateSlug: 'cas',
      name: 'College Ave',
      minAmount: 2000,
      maxAmount: 80000,
    },
    {
      slug: 'ascent',
      rateSlug: 'ascent',
      name: 'Ascent',
      minAmount: 2000,
      maxAmount: 200000,
    },
    {
      slug: 'invested',
      rateSlug: 'invested',
      name: 'INvestEd',
      minAmount: 1001,
      maxAmount: 80000,
    },
    {
      slug: 'cog-fin',
      rateSlug: 'cog-fin',
      name: 'Cognition Financial',
      minAmount: 1000,
      maxAmount: 99000,
      minCreditScore: 660,
    },
  ],
  OMITTED_LENDER_SLUGS = [
    'discover',
    'suntrust',
  ],
  availableLenders = allLenders.filter(lender => !OMITTED_LENDER_SLUGS.includes(lender.slug))

export { allLenders, availableLenders }
